import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CODE, RESPONSE_MESSAGE } from '../../../utils/Constant';
import { INSURANCE_STATUS } from '../../constants';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import { approveInsurance, cancelApproveInsurance } from '../../services';

const Action = () => {
	const { patientInfo, statusChange, setStatusChange } = usePhanHeBaoHiemYTeContext();

	const onButtonClick = async () => {
		try {
			const isVisitApproved = patientInfo?.nextStatusCode === INSURANCE_STATUS.UNAPPROVE;
			const patientId = patientInfo?.id;
			const { code } = isVisitApproved
				? await cancelApproveInsurance(patientId)
				: await approveInsurance(patientId);

			if (CODE.SUCCESS === code) {
				setStatusChange(!statusChange);
				toast.success(RESPONSE_MESSAGE.UPDATE.SUCCESS);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	if (!patientInfo?.id) return <></>;

	return (
		<div className="d-flex spaces px-10 py-4">
			<Button className="btn-fill" onClick={onButtonClick}>
				{patientInfo.nextStatusName}
			</Button>
		</div>
	);
};

export default Action;
